export enum LandingPageTypes {
    CUSTOM = "Custom Landing Page",
    STATIC = "Static Landing Page",
    CUSTOMER = "Customer Redirect URL"
}